import { useRedirectIfQuestionnaireUncompleted } from '@/hooks/use-redirect-if-questionnaire-uncompleted';
import { useGetTestingPlan } from '@/queries/testing-plan.queries';

export default function useTestingPlan() {
  const { isLoading: isLoadingTestingPlan } = useGetTestingPlan();
  const { isLoadingQuestionnaire } = useRedirectIfQuestionnaireUncompleted();

  const isLoading = isLoadingQuestionnaire || isLoadingTestingPlan;

  return { isLoading };
}
